window.ImportantInformation = (function () {
    window.dataLayer = window.dataLayer || [];
    let self = {
        elements: {
            buttons: {
                cancelButton: '#important-information-form-cancel',
                continueButton: '#important-information-form-continue'
            },
            checkbox:{
                checkBox1: '#important-information-form-checkbox1',
                checkBox2: '#important-information-form-checkbox2'
            },
            messages:{
                invalidFormMessage1: '#important-information-form-invalid-form-message1',
                invalidFormMessage2: '#important-information-form-invalid-form-message2'
            },
            checkBoxGroup1: '#important-information-form-checkBoxContainer1',
            checkBoxGroup2: '#important-information-form-checkBoxContainer2'
        },
        css: {
            invalidCheckboxError: 'vds-checkbox--invalid'
        },
        urls: {
            manageMembers: '/my-health-insurance/manage-my-plan/manage-members',
            resetSession: '/api/sitecore/AddMembers/ResetSession',
            errorPageUrl: '/error/error-page',
            confirmation: '/my-health-insurance/manage-my-plan/add-members/confirmation',
            saveMembersDetails: '/api/sitecore/AddMembers/SaveMembersDetails',
        },
        statusDescription: {
            accepted: 'accepted'
        },
        func: {
            init: function () {
                self.func.bindings();
                self.func.initializeValidationMessage();
            },
            bindings: function () {
                $(self.elements.buttons.continueButton).on('click', self.func.saveMembersDetails);
                $(self.elements.buttons.cancelButton).on('click', self.func.cancelAddMembersRequest);
                $(self.elements.checkbox.checkBox1).on('change', self.func.clearCheckBox1ValidationMessage);
                $(self.elements.checkbox.checkBox2).on('change', self.func.clearCheckBox2ValidationMessage);
            },
            initializeValidationMessage: function () {
                $(self.elements.messages.invalidFormMessage1).hide();
                $(self.elements.messages.invalidFormMessage2).hide();
            },
            saveMembersDetails: function (event) {
                event.preventDefault();
                self.func.clearValidationMessage();

                if (!$(self.elements.checkbox.checkBox1).is(':checked') ||
                    !$(self.elements.checkbox.checkBox2).is(':checked')) {

                    if (!$(self.elements.checkbox.checkBox1).is(':checked')) {
                        $(self.elements.messages.invalidFormMessage1).show();
                        $(self.elements.checkBoxGroup1).addClass(self.css.invalidCheckboxError);
                    }
                    if (!$(self.elements.checkbox.checkBox2).is(':checked')) {
                        $(self.elements.messages.invalidFormMessage2).show();
                        $(self.elements.checkBoxGroup2).addClass(self.css.invalidCheckboxError);
                    }
                    return;
                }

                $.ajax({
                    type: 'POST',
                    url: self.urls.saveMembersDetails,
                    data: {},
                    success: self.func.success,
                    error: self.func.error
                });
            },
            success: function (response) {
                if (response.statusCode.toLowerCase() === self.statusDescription.accepted) {
                    window.location.href = self.urls.confirmation;
                } else {
                    window.location.href = self.urls.errorPageUrl;
                }
            },
            error: function () {
                window.location.href = self.urls.errorPageUrl;
            },
            cancelAddMembersRequest: function (event) {
                event.preventDefault();
                // AJAX call to reset the session.
                $.post(self.urls.resetSession)
                    .done(function () {
                        window.location.href = self.urls.manageMembers;
                    })
                    .fail(function () {
                        window.location.href = self.urls.errorPageUrl;
                    });
            },
            clearValidationMessage: function () {
                $(self.elements.messages.invalidFormMessage1).hide();
                $(self.elements.messages.invalidFormMessage2).hide();
                $(self.elements.checkBoxGroup1).removeClass(self.css.invalidCheckboxError);
                $(self.elements.checkBoxGroup2).removeClass(self.css.invalidCheckboxError);
            },
            clearCheckBox1ValidationMessage: function () {
                $(self.elements.messages.invalidFormMessage1).hide();
                $(self.elements.checkBoxGroup1).removeClass(self.css.invalidCheckboxError);
            },
            clearCheckBox2ValidationMessage: function () {
                $(self.elements.messages.invalidFormMessage2).hide();
                $(self.elements.checkBoxGroup2).removeClass(self.css.invalidCheckboxError);
            }
        }
    };

    return {
        Init: self.func.init
    };
})();

$(document).ready(function () {
    if ('importantInformation' === $('#important-information-form').data('feature')) {
        window.ImportantInformation.Init();
    }
});
